import { Either, Option } from 'funfix-core';
const findBetweenTiers = (pricingItems, numUsers) => pricingItems.reduce((foundBetweenTiers, pricingItem, index, iter) => foundBetweenTiers.orElseL(() => pricingItem.unitCount >= numUsers ? Option.some({
  lower: Option.of(index === 0 ? null : iter.get(index - 1)),
  upper: pricingItem
}) : Option.empty()), Option.empty()).map(Either.right).getOrElse(Either.left('Number of users does not fall between any tiers'));
export default findBetweenTiers;